import { render, staticRenderFns } from "./Counts.vue?vue&type=template&id=b27e3ff6&scoped=true"
import script from "./Counts.vue?vue&type=script&lang=js"
export * from "./Counts.vue?vue&type=script&lang=js"
import style0 from "./Counts.vue?vue&type=style&index=0&id=b27e3ff6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27e3ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b27e3ff6')) {
      api.createRecord('b27e3ff6', component.options)
    } else {
      api.reload('b27e3ff6', component.options)
    }
    module.hot.accept("./Counts.vue?vue&type=template&id=b27e3ff6&scoped=true", function () {
      api.rerender('b27e3ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Sidebar/Counts.vue"
export default component.exports